import type { InventoryReportItemDto } from "@/api/dtos";
import type { InventoryReportItem } from "@/api/report/_models/InventoryReport";

/** DTO → domain for an inventory stock row. */
export const toInventoryReportItemFromDto = (dto: InventoryReportItemDto): InventoryReportItem => {
  return {
    company: dto.company,
    warehouse: dto.warehouse,
    item: dto.item,
    description: dto.description,
    onHandQuantity: dto.onHandQuantity,
    availableToSell: dto.availableToSell,
    inProcessQuantity: dto.inProcessQuantity,
    heldQuantity: dto.heldQuantity,
    suspenseQuantity: dto.suspenseQuantity,
    demandQuantity: dto.demandQuantity,
  };
};
